enum ImportMode {
	ImportNewProjects = 'ImportNewProjects',
	ImportPhasesTasksTimeRegs = 'ImportPhasesTasksTimeRegs',
	ImportTimeRegs = 'ImportTimeRegs',
}

export default ImportMode;
